import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default (text: string | undefined): string => {
    const origin = getUmbracoEndPoint();

    if (!text) {
        return "";
    }

    text = text.toString()
        .replace(new RegExp(origin, "g"), "")
        .replace(new RegExp("http://localhost:3000", "g"), "")
        .replace(new RegExp("https://stage.rekom.frontend.heyday.dk", "g"), "")
        .replace(new RegExp("https://production.rekom.frontend.heyday.dk", "g"), "");

    return text.toString();
};